import {
  server,
  TRANSACTION_FAILED,
  TRANSACTION_FETCHING,
  TRANSACTION_SUCCESS
} from '../../constants'
import apiEndpoint from '../../api/etrBackend'
import { ConvertToSearchDateFormat } from '../../helpers/texthelper'

const setStateTransactionToSuccess = (payload: any) => ({
  type: TRANSACTION_SUCCESS,
  payload: payload
})

const setStateTransactionToFetching = () => ({
  type: TRANSACTION_FETCHING
})

const setStateTransactionToFailed = () => ({
  type: TRANSACTION_FAILED
})

export const getTransactions = (
  agentId: string,
  isAO: boolean,
  isBranch: boolean,
  page: number,
  itemsPerPage: number,
  keyword: string,
  status: string
) => {
  const search = `?pageSize=${itemsPerPage}&page=${page}&status=${status}&keyword=${ConvertToSearchDateFormat(
    keyword
  )}`
  let apiUrl = server.TRANSACTION_URL + `/agent/${agentId}`
  if (window._env_.NODE_ENV === 'local') {
    apiUrl = `${server.TRANSACTION_URL}`
  }
  if (isAO) {
    apiUrl = apiUrl + '/AO'
  }
  if (isBranch) {
    //apiUrl = server.TRANSACTION_URL + '/BRANCH'
    apiUrl = server.TRANSACTION_URL + `/pagination`
  }

  return (dispatch: any) => {
    dispatch(setStateTransactionToFetching())

    apiEndpoint
      .get(apiUrl + search)
      .then(result => {
        dispatch(setStateTransactionToSuccess(result.data))
      })
      .catch(err => {
        console.log(err)
        dispatch(setStateTransactionToFailed())
      })
  }
}
